module.exports = __webpack_public_path__ + "static/media/events.8a98e327.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/events.svg
// module id = 1693
// module chunks = 53